import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-down",
  "use": "chevron-down-usage",
  "viewBox": "0 0 12 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 7\" id=\"chevron-down\"><path d=\"M5.904 5.127L10.538.659a.566.566 0 01.804.017c.217.228.21.59-.017.81L6.289 6.34a.566.566 0 01-.796-.009L.667 1.477a.575.575 0 010-.81.566.566 0 01.804 0l4.433 4.46z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol